<template>
  <div
    ref="containerRef"
    class="mb-2 text-center"
    :class="{
      'hide-scrollbar flex w-full space-x-2 overflow-x-auto scroll-smooth':
        isPdp,
      'block text-center lg:flex': !isPdp,
    }"
  >
    <slot :items="items">
      <component
        :is="tag"
        v-for="(item, idx) in items"
        :key="item.value"
        :to="{ name: 'product' }"
      >
        {{ item.label || item.value }}
        <template v-if="showDividerTag(idx, items.length)">
          <span class="inline-block pl-1 pr-2.5 pt-1 align-middle">
            <IconUiArrowRight />
          </span>
        </template>
      </component>
    </slot>
  </div>
</template>

<script lang="ts">
type DividerItemType = 'p' | 'nuxt-link'
export interface DividerItem {
  value: string
  label?: string
  to?: { name: string; params?: object } | string
}
export default defineComponent({
  name: 'ItemsDivider',
  props: {
    tag: {
      type: String as PropType<DividerItemType>,
      default: 'p',
    },
    items: {
      type: Array as PropType<DividerItem[]>,
      default: () => [],
    },
    isPdp: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const containerRef = ref<HTMLDivElement | null>(null)
    const scrollToLastItem = () => {
      if (props.isPdp && containerRef.value) {
        const lastItem = containerRef.value.querySelector(
          ':scope > *:last-child',
        ) as HTMLElement | null
        if (lastItem) {
          lastItem.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'end',
          })
        }
      }
    }
    onMounted(() => {
      scrollToLastItem()
    })
    return {
      containerRef,
    }
  },
})
</script>

<style scoped>
.hide-scrollbar {
  scrollbar-width: none;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}
.hide-scrollbar::-webkit-scrollbar {
  width: 0 !important;
  display: none !important;
}
</style>
